export default __webpack_public_path__ + "static/media/46.e30173fc.png";